import { isNil } from 'lodash-es';

export const isNotNil = <T>(x: T | undefined | null): x is T => !isNil(x);

export function assertIsNotNill<T>(x: T | undefined | null): asserts x is T {
	if (isNil(x)) {
		throw new Error('Not null or undefined constraint violated!');
	}
}
